import { render, staticRenderFns } from "./NuovaDichiarazioneModal.vue?vue&type=template&id=353ab94e&"
import script from "./NuovaDichiarazioneModal.vue?vue&type=script&lang=js&"
export * from "./NuovaDichiarazioneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NuovaDichiarazioneModal.vue"
export default component.exports